<div class="decision-calendar__agenda" *ngIf="viewModel as view">
  <div class="decision-calendar__agenda-nav">
    <button type="button" class="decision-calendar__agenda-nav-button"
      [attr.aria-label]="lang.translate('home.calendar.agenda.previousMonth')" (click)="monthNavigate.emit(-1)">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="decision-calendar__agenda-month">{{ monthTitle }}</span>
    <button type="button" class="decision-calendar__agenda-nav-button"
      [attr.aria-label]="lang.translate('home.calendar.agenda.nextMonth')" (click)="monthNavigate.emit(1)">
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
    <button type="button" class="decision-calendar__agenda-today" (click)="todayRequest.emit()">
      {{ lang.translate('home.calendar.agenda.today') }}
    </button>
  </div>

  <p class="decision-calendar__agenda-empty" *ngIf="!populatedDays.length && !view.undatedEntries.length">
    {{ lang.translate('home.calendar.agenda.empty') }}
  </p>

  <ol class="decision-calendar__agenda-list" *ngIf="populatedDays.length">
    <li class="decision-calendar__agenda-day" *ngFor="let day of populatedDays; trackBy: trackDay">
      <div class="decision-calendar__agenda-day-header" [class.is-today]="day.isToday">
        <span class="decision-calendar__agenda-day-date">{{ day.date | date: 'EEEE d' }}</span>
        <span class="decision-calendar__agenda-day-badge" *ngIf="day.isToday">
          {{ lang.translate('home.calendar.agenda.todayBadge') }}
        </span>
        <span class="decision-calendar__day-total">{{ day.entries.length }}</span>
      </div>
      <div class="decision-calendar__agenda-day-items">
        <button type="button" class="decision-calendar__entry"
          *ngFor="let entry of day.entries; trackBy: trackEntry"
          [class.is-selected]="selectedDecisionId === entry.decisionId" [attr.data-state]="entry.state"
          (click)="selectDecision.emit(entry.decisionId)">
          <span class="decision-calendar__entry-icon" aria-hidden="true">
            <i [class]="'fa ' + getStateIconClass(entry.state)"></i>
          </span>
          <span class="decision-calendar__entry-copy">
            <span class="decision-calendar__entry-title">{{ formatDecisionTitle(entry.title) }}</span>
            <span class="decision-calendar__entry-meta">{{ getStateLabel(entry.state) }}</span>
            <span class="decision-calendar__entry-reason">{{ entry.shortReason }}</span>
            <span class="decision-calendar__entry-secondary" *ngIf="entry.ownerLabel">{{ entry.ownerLabel }}</span>
          </span>
        </button>
      </div>
    </li>
  </ol>

  <section class="decision-calendar__agenda-undated" *ngIf="view.undatedEntries.length">
    <h3 class="decision-calendar__agenda-undated-title">{{ lang.translate('home.calendar.undated') }}</h3>
    <button type="button" class="decision-calendar__entry"
      *ngFor="let entry of view.undatedEntries; trackBy: trackEntry"
      [class.is-selected]="selectedDecisionId === entry.decisionId" [attr.data-state]="entry.state"
      (click)="selectDecision.emit(entry.decisionId)">
      <span class="decision-calendar__entry-icon" aria-hidden="true">
        <i [class]="'fa ' + getStateIconClass(entry.state)"></i>
      </span>
      <span class="decision-calendar__entry-copy">
        <span class="decision-calendar__entry-title">{{ formatDecisionTitle(entry.title) }}</span>
        <span class="decision-calendar__entry-meta">{{ getStateLabel(entry.state) }}</span>
      </span>
    </button>
  </section>
</div>
